import { IconProps } from './types';

export const AddIcon = (props: IconProps) => (
  <svg viewBox="0 0 28 28" fill={props?.fill || '#fff'} xmlns="http://www.w3.org/2000/svg" className={props?.className}>
    <path
      // eslint-disable-next-line max-len
      d="M14 5C14.5523 5 15 5.44772 15 6V13H22C22.5523 13 23 13.4477 23 14C23 14.5523 22.5523 15 22 15H15V22C15 22.5523 14.5523 23 14 23C13.4477 23 13 22.5523 13 22V15H6C5.44772 15 5 14.5523 5 14C5 13.4477 5.44772 13 6 13H13V6C13 5.44772 13.4477 5 14 5Z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);
